module.exports = __webpack_public_path__ + "img/icons-40-perks-work-hard.b904cfab.svg";